import { render, staticRenderFns } from "./BuyerSearch.vue?vue&type=template&id=55995522&"
import script from "./BuyerSearch.vue?vue&type=script&lang=js&"
export * from "./BuyerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports